import {
    CloseOutlined,
    FilterAltOffOutlined,
    FilterAltOutlined,
} from "@mui/icons-material";
import {
    Alert,
    Box,
    Button,
    Card,
    Grid,
    IconButton,
    TextField,
    Typography,
} from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { GET } from "../../../Utilities/BaseService";
import BaseTable from "../../Table/BaseTable";
import SearchBar from "../../Table/Components/SearchBar";
const initialClearAll = {
    search: false,
    startDate: false,
    endDate: false,
};

const CreditPaymentLeasureMonthWise = () => {
    const [filter, setFilter] = useState({
        search: "",
        meterNo: "",
        month: "",
        year: "",
        billingMonth: "",
    });
    const [clearAll, setClearAll] = useState(initialClearAll);

    const handleClearAll = () => {
        // reset UI filters

        // reset applied filters
        setFilter({ ...filter, search: "" });

        // notify searchable inputs
        setClearAll({
            search: true,
            startDate: true,
            endDate: true,
        });

        setFilter({
            ...filter,
            search: "",
            month: "",
            year: "",
            billingMonth: "",
        });

        // reset search trigger & pagination
        setChangeCount(0);
        setPagination({ page: 0, limit: 100 });

        // reset flags after one render
        setTimeout(() => setClearAll(initialClearAll), 0);
    };

    const [rowsCount, setRowsCount] = useState(0);
    const [pagination, setPagination] = useState({ page: 0, limit: 100 });
    const [changeCount, setChangeCount] = useState(0);
    const [feedback, setFeedback] = useState("");

    const currentMonth = new Date().toISOString().slice(0, 7); // YYYY-MM

    const getCreditPayments = () => {
        const [year, month] = filter.billingMonth?.split("-") ?? ["", ""];
        return GET("/reading/leisure-summary-month-wise", {
            page: pagination.page + 1,
            limit: pagination.limit,
            meterNo: filter.search || undefined,
            month: month || undefined,
            year: year || undefined,
        });
    };

    const { data, isLoading } = useQuery(
        ["advance", pagination.page, pagination.limit, filter],
        getCreditPayments,
        {
            enabled: Boolean(changeCount),
            onSuccess(res) {
                if (res) setRowsCount(res?.data.count);
            },
        }
    );


    useEffect(() => {
        if (changeCount > 0) {
            setFilter((prev) => ({
                ...prev,
                meterNo: prev.search,
            }));
        }
    }, [changeCount]);

    return (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Card elevation={0} sx={{ p: 2, mb: "1rem" }}>
                <Grid container spacing={1.5}>
                    <Grid item xs={12} md="auto">
                        <Typography color="GrayText" variant="h5">
                            Credit Payments ledger Month Wise
                        </Typography>
                    </Grid>
                </Grid>

                <Grid item container xs={12} spacing={1.5} pt={2}>
                    <Grid item xs={12} md={4}>
                        <SearchBar
                            filter={filter}
                            setFilter={setFilter}
                            clear={clearAll.search}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} lg={3}>
                        <TextField
                            size="small"
                            name="billingMonth"
                            label="Billing month"
                            type="month"
                            fullWidth
                            value={filter.billingMonth}
                            onChange={(e) =>
                                setFilter({
                                    ...filter,
                                    billingMonth: e.target.value,
                                })
                            }
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                                max: currentMonth, // ✅ prevents forward months
                            }}
                            InputProps={{
                                endAdornment: filter?.billingMonth ? (
                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            setFilter({
                                                ...filter,
                                                billingMonth: "",
                                            })
                                        }
                                    >
                                        <CloseOutlined />
                                    </IconButton>
                                ) : null,
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Button
                            color="secondary"
                            variant="outlined"
                            startIcon={<FilterAltOutlined />}
                            onClick={() => setChangeCount((prev) => prev + 1)}
                            sx={{ minWidth: "20ch", height: "100%" }}
                            fullWidth
                        >
                            Search
                        </Button>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Button
                            color="error"
                            variant="outlined"
                            startIcon={<FilterAltOffOutlined />}
                            onClick={handleClearAll}
                            sx={{ minWidth: "20ch", height: "100%" }}
                            fullWidth
                        >
                            Clear All
                        </Button>
                    </Grid>
                </Grid>

                {filter.search === "" ? (
                    <Alert severity="info" style={{ marginTop: "1rem" }}>
                        Must provide Meter No. in order to view credit payment
                        leasure. leisure.
                    </Alert>
                ) : (
                    <Box sx={{ height: "70%" }}>
                        <BaseTable
                            headers={{
                                meterNo: "Meter No.",
                                name: "Name",
                                startBalance: "Start Balance",
                                balancedUsed: "Balance Used",
                                balanceRemaining: "Balance Remaining",
                                districtName: "District",
                                villageName: "Village",
                                hamletName: "Hamlet",
                                powerstationName: "Power Station",
                                billingMonth: "Billing Month",
                            }}
                            data={
                                data &&
                                data?.data.rows.map((row: any) => ({
                                    ...row,
                                    meterNo: row.meterNo,
                                    name: row?.customerName,
                                    startBalance: row.startBalance,
                                    balancedUsed: row.usedBalance,
                                    balanceRemaining: row.remainingBalance,
                                    districtName: row.districtName,
                                    villageName: row.villageName,
                                    hamletName: row.hamletName,
                                    powerstationName: row.powerstationName,
                                    billingMonth: `${row.month}/${row.year}`,
                                }))
                            }
                            delEndPoint=""
                            defaultSelectedHeaders={["id"]}
                            feedback={feedback}
                            setFeedback={setFeedback}
                            rowsCount={rowsCount}
                            pagination={pagination}
                            setPagination={setPagination}
                            isLoading={isLoading}
                            load={Boolean(changeCount)}
                            permissions={{
                                edit: ["NO EDIT"],
                                delete: ["NO DELETE"],
                            }}
                            queryKey={[
                                "advance",
                                pagination.page,
                                pagination.limit,
                                filter,
                            ]}
                            reportName="CreditPayment__List"
                        />
                    </Box>
                )}
            </Card>
        </Box>
    );
};

export default CreditPaymentLeasureMonthWise;